export const weekEndingMapping = {
  'Twelve':12,
  'Eight':8,
  'Four':4
}